import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-workflow-status',
  templateUrl: './status.component.html',
  styleUrls: ['./status.component.css']
})
export class StatusComponent implements OnInit {

  @Input() status: number;
  @Input() qrCode: number;

  constructor() { }

  ngOnInit(): void {
  }

}
